import { type P2PFilterOrganization } from '../../../../services/peerToPeer/DashboardService'
import { type ScopeOption } from '../ScopeFilter'

const LEVEL_ORDER = ['State', 'RCN', 'ISD', 'District']
const LEVEL_LABEL: Record<string, string> = { State: 'State of Michigan', RCN: 'RCN', ISD: 'ISD', District: 'District' }
const LEVEL_PLURAL: Record<string, string> = { State: 'State', RCN: 'RCNs', ISD: 'ISDs', District: 'Districts' }

export interface ScopeFilterOptions {
  levelOptions: ScopeOption[]
  /** Null at the ceiling: that option already means "my whole scope", so there is nothing to pick. */
  orgOptions: ScopeOption[] | null
}

/**
 * "Filter by [level]" options. The ceiling is the highest level the caller can reach and is
 * labelled with their own organization's name; below it sit only the levels their scope
 * actually contains orgs at.
 */
export const scopeFilterOptions = (
  ceiling: string,
  currentOrgId: number,
  selectedLevel: string,
  filterOrgs: P2PFilterOrganization[]
): ScopeFilterOptions => {
  const ceilingLabel = ceiling === 'State'
    ? LEVEL_LABEL.State
    : (filterOrgs.find(org => org.id === currentOrgId)?.name ?? LEVEL_LABEL[ceiling] ?? 'My organization')

  const levelsBelowCeiling = LEVEL_ORDER
    .slice(LEVEL_ORDER.indexOf(ceiling) + 1)
    .filter(level => filterOrgs.some(org => org.type === level))

  return {
    levelOptions: [
      { value: ceiling, label: ceilingLabel },
      ...levelsBelowCeiling.map(level => ({ value: level, label: LEVEL_LABEL[level] }))
    ],
    orgOptions: selectedLevel === ceiling
      ? null
      : [
          { value: 'all', label: `All ${LEVEL_PLURAL[selectedLevel]}` },
          ...filterOrgs.filter(org => org.type === selectedLevel).map(org => ({ value: String(org.id), label: org.name }))
        ]
  }
}
